import { gql } from '@apollo/client';

export const ACCOUNTSTATEMENTS_QUERY = gql`
  query Query($pager: PagerInputNew, $filters: AccountStatementFilterInput) {
    accountStatements(pager: $pager, filters: $filters) {
      values {
        configId
        configName
        configVersion
        activeYN
      }
      total
    }
  }
`;